import { chartColors } from '@/config/charts';

/**
 * Given a color index, returns the configured chart color for that index.
 * @param {number} index - The index of the chart color to pull.
 * @returns {string} The chart color at the given index.
 */
const getChartColor = (index) => chartColors[index] ?? '#000';

export default getChartColor;
